import { z } from "zod";
export const invalidateMemberAuthorityRequestSchema = z.object({
    userId: z.string().trim().min(1).max(256), role: z.enum(["org:admin", "org:member"]),
}).strict();
